<template>
  <div class="team-switcher">
    <v-progress-circular
      color="grey"
      indeterminate
      v-if="isLoading"
    />

    <template v-else>
      <button class="team-button" @click="isShowingDropdown = !isShowingDropdown">
        <template v-if="currentTeam">
          <div class="flex items-start gap-2 overflow-hidden">
            <team-avatar :team="currentTeam" />

            <div class= "flex flex-col text-left overflow-hidden">
              <div class= "font-bold text-lg truncate">{{ currentTeam.name }}</div>
              <div class="text-sm">{{ prettyRole(currentTeam.role) }}</div>
            </div>
          </div>  
        </template>

        <template v-else>
          <span class="text-sm">Selecione uma conta</span>
        </template>

        <v-icon>
          {{ isShowingDropdown ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </button>

      <div class="team-dropdown" v-if="isShowingDropdown">
        <button
          class="team-option"
          :class="{ active: team.id === currentTeamId }"
          :key="team.id"
          @click="onClick(team)"
          v-for="team in teams"
        >
          <div class="team-bar" v-if="team.id === currentTeamId"></div>
          <team-avatar :team="team" />

          <div class= "flex flex-col text-left overflow-hidden">
            <div class= "font-bold text-lg truncate">{{ team.name }}</div>
            <div class="text-sm">{{ prettyRole(team.role) }}</div>
          </div>

          <v-icon
            color="blue-500"
            v-if="team.id === currentTeamId"
          >
            mdi-check
          </v-icon>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TeamAvatar from '@/components/teams/TeamAvatar';

export default {
  name: 'TeamSwitcher',

  components: {
    TeamAvatar,
  },

  data() {
    return {
      currentTeam: null,
      isLoading: true,
      isShowingDropdown: false,
      teams: [],
    };
  },

  mounted() {
    this.fetchTeams();
  },

  computed: {
    ...mapGetters('team', {
      teamContext: 'GET_CONTEXT',
      teamId: 'GET_TEAM_ID',
    }),

    currentTeamId() {
      return this.teamContext?.realTeamId;
    },
  },

  methods: {
    async fetchTeams() {
      this.isLoading = true;

      try {
        this.teams = await this.$store.dispatch('team/fetchTeams');
        this.teams.sort((a, b) => a.name.localeCompare(b.name));

        this.setCurrentTeam(this.teamContext);
      } catch (error) {
        console.error(error);
      }

      this.isLoading = false;
    },

    prettyRole(role) {
      switch (role) {
        case 'owner':
          return 'Titular';
        case 'manager':
          return 'Gerente';
        case 'receptionist':
          return 'Recepcionista';
        default:
          return 'Membro';
      }
    },

    async onClick(team) {
      this.$store.dispatch('team/setContext', {
        type: 'team',
        teamId: team.ownerId,
        realTeamId: team.id,
      });
      this.$store.dispatch('team/setTeamsChecked', true);
      this.$router.push({ name: 'doctor-dashboard' });
      this.isShowingDropdown = false;
    },

    setCurrentTeam(context) {
      this.currentTeam = this.teams.find(team => team.id === context?.realTeamId);
    },
  },

  watch: {
    teamContext: {
      handler(newVal) {
        this.setCurrentTeam(newVal);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.team-switcher {
  position: relative;
}

.team-switcher-label {
  font-size: 12px;
  font-weight: 500;
  color: #6B7280;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.team-button {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  cursor: pointer;
  transition: all 200ms ease;
  justify-content: space-between;
  overflow: hidden;
}

.team-button:hover {
  background: #F3F4F6;
  border-color: #D1D5DB;
}

.team-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 8px;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.team-option {
  position: relative;
  background: none;
  border: none;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s;
}

.team-option:not(:last-child) {
  border-bottom: 1px solid #F3F4F6;
}

.team-option:hover {
  background: #F3F4F6;
}

.team-option.active {
  background: #E9EEFE;
}

.team-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: #a2b5f3;
  border-radius: 12px;
}
</style>
